import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import permissionCheck, { PermissionProps } from '../../utils/permission/permissionCheck';

const usePermissionCheck = (
  props: PermissionProps & { redirectTo?: string; shouldRedirect?: boolean }
) => {
  const navigate = useNavigate();

  const hasPermission = permissionCheck(props);

  useEffect(() => {
    if (props?.shouldRedirect && !hasPermission) {
      navigate(props?.redirectTo ?? '/');
    }
  }, [hasPermission]);

  return hasPermission;
};

export default usePermissionCheck;
